import { Box, TableCell } from '@mui/material';
import { GridCellProps } from '@progress/kendo-react-grid';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { usePositionCellStyles } from './positionCellStyles';

export const PositionCell = ({ dataItem, rowType }: GridCellProps) => {
  const sxStyles = usePositionCellStyles();
  const { internalPosition } = dataItem;
  const { t } = useTranslation();

  if (!internalPosition || rowType !== 'data') {
    return null;
  }

  return (
    <TableCell sx={sxStyles.dataCell}>
      <Box sx={sxStyles.text}>
        {internalPosition.position ? internalPosition.position : ''}
        <p>
          {t('sinceDate', {
            date: moment(internalPosition.startDate).format('L'),
          })}
        </p>
      </Box>
    </TableCell>
  );
};
